import { type FC } from 'react'
import classNames from 'classnames'
import { pluralizeMeetingType } from '../pluralizeMeetingType'
import styles from './MeetingInsightsEmptyState.module.scss'

interface MeetingInsightsEmptyStateProps {
  meetingTypeName: string
  timeRangeLabel: string
}

export const MeetingInsightsEmptyState: FC<MeetingInsightsEmptyStateProps> = ({ meetingTypeName, timeRangeLabel }) => {
  return (
    <div className='d-flex flex-column align-items-center zocks-gap-1 zocks-p-2.0 mx-auto w-100'>
      <div
        className={classNames(
          'd-flex align-items-center justify-content-center flex-shrink-0 zocks-bg-color-gray-100 border zocks-border-color-gray-200 zocks-border-0.5 zocks-text-primary',
          styles.iconBox,
        )}
      >
        <i className='bi bi-lightbulb-off fs-6' aria-hidden />
      </div>
      <div className='d-flex flex-column align-items-center text-center zocks-gap-0.25 w-100'>
        <p className='m-0 fw-bold paragraph-medium zocks-text-gray-900'>
          No {pluralizeMeetingType(meetingTypeName)} in the last {timeRangeLabel}.
        </p>
        <p className='m-0 paragraph-small zocks-text-gray-700'>Start holding these meetings to see patterns.</p>
      </div>
    </div>
  )
}
